import moment from "moment";

/**
 * eventFormat — shared, civilian (12-hour) event date/time formatters
 * (SPR-009 P2-1/P2-2).
 *
 * Single source of truth so the public Events feed, the event detail page, and
 * the Home event-feed row all render dates/times identically — and always in
 * 12-hour AM/PM (no 24-hour/military time). Input times are the API's
 * `HH:mm:ss` strings (24-hour wire format); output is always `h:mm A`.
 */

/**
 * formatEventDate — ISO date (YYYY-MM-DD) → e.g. "Sat, Jul 4".
 * @param {string} date
 * @returns {string}
 */
export function formatEventDate(date) {
  if (!date) return "";
  return moment(date, "YYYY-MM-DD").format("ddd, MMM D");
}

/**
 * eventMonthAbbrev — ISO date → uppercase 3-letter month, e.g. "JUL".
 * @param {string} date
 * @returns {string}
 */
export function eventMonthAbbrev(date) {
  if (!date) return "";
  return moment(date, "YYYY-MM-DD").format("MMM").toUpperCase();
}

/**
 * eventDayOfMonth — ISO date → day number as a string, e.g. "4".
 * @param {string} date
 * @returns {string}
 */
export function eventDayOfMonth(date) {
  if (!date) return "";
  return moment(date, "YYYY-MM-DD").format("D");
}

/**
 * formatTimeRange — start/end (HH:mm:ss) → "2:00 PM – 6:00 PM" (12-hour).
 * @param {string} [start]
 * @param {string} [end]
 * @returns {string}
 */
export function formatTimeRange(start, end) {
  const fmt = (t) => moment(t, "HH:mm:ss").format("h:mm A");
  if (start && end) return `${fmt(start)} – ${fmt(end)}`;
  if (start) return fmt(start);
  return "Time TBA";
}
